module.exports = __webpack_public_path__ + "static/img/service-row2.ae88638.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/service-row2.png
// module id = H5X9
// module chunks = 1